const devbarHeight = 36;

/**
 * This constant is used for easy management of z-indexes
 * The lowest number will be rendered first, the higher numbers will overlap it
 * If you want to add a new number in between, remember to update the overlapping numbers
 * None of the numbers can be the same
 *
 * According to google:
 * min value: -2147483647
 * max value: 2147483647
 */
const zIndexes = {
    navigation: 1000,
    microFrontendCards: 2000,
    devbar: 3000,
    notifications: 4000,
    headers: 900,
    footers: 900,
};

export { devbarHeight, zIndexes };
